export default "__VITE_ASSET__i3H9ws83__"